import { render, staticRenderFns } from "./UserEditDialog.vue?vue&type=template&id=90786664&scoped=true"
import script from "./UserEditDialog.vue?vue&type=script&lang=ts"
export * from "./UserEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90786664",
  null
  
)

export default component.exports